export default {
  /** Array: Templates of all teams as an array */
  allTemplates(state, getters) {
    return Object.values(state.templatesPerTeam).reduce((all, templates) => [...all, ...templates], []);
  },

};
